<template>
  <div class="confirm-order-container">
    <div class="confirm-order-wrapper">
      <div class="confirm-text">确认提交订单？</div>
      <div class="btn-view">
        <div @click="cancelOrder" class="cancel">取消</div>
        <div @click="confirmOrder" class="confirm">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmOrder',
  methods: {
    confirmOrder () {
      this.$emit('submit')
    },
    cancelOrder () {
      this.$emit('toggleShowConfirmOrder')
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-order-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  background: rgba( 0, 0, 0, .5);
  z-index: 9999;
  .confirm-order-wrapper {
    width: 360px;
    height: 150px;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    .confirm-text {
      width: 100%;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #333333;
      border-bottom: 1px solid #e0e0e0;
    }
    .btn-view {
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: row;
      .cancel {
        width: 50%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #999999;
        cursor: pointer;
      }
      .confirm {
        width: 50%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
        background-color: #ff9a28;
        border-radius: 0px 0px 10px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopping_cart/confirm_order.vue